export const formatDateShort = (dateString, lang = "en") => {
    const date = new Date(dateString);

    // Gregorian (Christian)
    const gregorian = new Intl.DateTimeFormat("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric",
    }).format(date);

    // Persian (Solar Hijri - Jalali)
    const persian = new Intl.DateTimeFormat("fa-IR-u-ca-persian", {
        year: "numeric",
        month: "long",
        day: "numeric",
    }).format(date);

    if (lang === "fa") {
        return persian
    }
    return gregorian

};

export const getRemainingDays = (expiresAt) => {
    const now = new Date();
    const expireDate = new Date(expiresAt);

    // Difference in milliseconds
    const diff = expireDate - now;

    // Convert ms → days
    const remaining = Math.ceil(diff / (1000 * 60 * 60 * 24));

    return remaining > 0 ? remaining : 0; // no negative days
};